<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-datepicker
            :range="true"
            type="month"
            label="점검기간"
            name="period"
            v-model="searchParam.period"
            @datachange="getList"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="관리감독자 ESF 체크리스트 목록"
      :columns="grid.columns"
      :data="grid.data"
    >
      <template slot="table-chip">
        <span class="q-ml-sm" style="font-size: 0.9em">✔️ 선해임에서 각 부서의 ESF담당자로 지정된 분만 등록 가능합니다. 관리감독자 체크리스트 대상에서 해제된 부서는 신규등록이 불가능합니다.</span>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="deptColNames.indexOf(col.name) > -1 && (!col.redCol || ['Y', 'P'].includes(props.row[col.name]))">
          <!--
            submitFlag 없음(=미래 점검월, 아직 작성 시작 안 함) -> 회색 "작성"
            submitFlag === 'Y'(검사대상 주차x부서가 전부 수취완료) -> 초록 "제출완료"
            submitFlag === 'P'(작성은 시작됐으나 하나라도 미완료, 미래/과거 상관없음) -> 파랑 "작성중"
            submitFlag === 'N'(작성이 시작조차 안 됐고 현재/과거월이라 도래함) -> 빨강 "미제출"
            단, 대상해제(회색) 부서 컬럼은 작성중/제출완료가 아니면 아예 표시하지 않는다.
          -->
          <b
            class="cursor-pointer"
            :class="`text-${chipColor(props.row[col.name])}`"
            @click="openPop(props.row, col)"
          >
            {{ chipLabel(props.row[col.name]) }}
          </b>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'supervisor-checklist-list',
  data() {
    let currentYear = new Date().getFullYear();
    return {
      searchParam: {
        // 기본값: 당해 1월 ~ 12월
        period: [`${currentYear}-01`, `${currentYear}-12`],
      },
      // 목록조회 결과에서 동적으로 채워지는 부서 컬럼명 목록
      deptColNames: [],
      grid: {
        columns: [
          {
            name: 'checkMonth',
            field: 'checkMonth',
            label: '점검월',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sup.checklist.list.url;
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        startMonth: this.searchParam.period[0],
        endMonth: this.searchParam.period[1],
      };
      this.$http.request((_result) => {
        this.setDynamicColumns(_result.data);
        this.grid.data = this.$_.map(_result.data, row => {
          let flat = { checkMonth: row.checkMonth };
          this.$_.forEach(row.deptStatuses, dept => {
            flat[dept.deptCd] = dept.submitFlag;
            flat[dept.deptCd + 'Id'] = dept.supervisorChecklistId;
            flat[dept.deptCd + 'DeptName'] = dept.deptName;
          });
          return flat;
        });
      },);
    },
    // 부서목록(=열)은 조회결과에 따라 달라지므로 조회 시마다 동적으로 컬럼을 구성한다.
    setDynamicColumns(list) {
      if (!list || list.length === 0) return;
      let deptCols = this.$_.map(list[0].deptStatuses, dept => {
        return {
          name: dept.deptCd,
          field: dept.deptCd,
          label: dept.deptName,
          align: 'center',
          style: 'width:100px',
          type: 'custom',
          sortable: false,
          helpcomment: dept.esfSeniorName ? 'ESF담당자: ' + dept.esfSeniorName : '',
          // 비활성(checklistFlag !== 'Y') 부서는 이력 조회용으로만 남아있는 컬럼임을 구분 표시
          redCol: dept.checklistFlag !== 'Y',
        };
      });
      this.deptColNames = this.$_.map(deptCols, 'name');
      this.grid.columns = [this.grid.columns[0], ...deptCols];
    },
    chipColor(submitFlag) {
      if (submitFlag === 'Y') return 'green';
      if (submitFlag === 'P') return 'blue';
      if (submitFlag === 'N') return 'red-5';
      return 'grey-6';
    },
    chipLabel(submitFlag) {
      if (submitFlag === 'Y') return '제출완료';
      if (submitFlag === 'P') return '작성중';
      if (submitFlag === 'N') return '미제출';
      return '작성예정';
    },
    openPop(row, col) {
      this.popupOptions.title = `관리감독자 ESF 체크리스트 상세 (${row.checkMonth} / ${row[col.name + 'DeptName']})`;
      this.popupOptions.param = {
        checkMonth: row.checkMonth,
        upDeptCd: col.name,
      };
      this.popupOptions.target = () => import(`${'./supervisorChecklistDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
